import AsyncLoader from 'components/AsyncLoader';

const GetTheAppPopup = AsyncLoader(
  () => import(/* webpackChunkName: "GetTheAppPopup" */ '@picsart/rc/old/GetTheAppPopup'),
);

export default GetTheAppPopup;
